<template>
	<div>
		<PageHeader
			:data="{
				name: 'Notifications',
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Clients', to: '/clients' },
				],
			}"
		/>
		<div class="actions d-flex justify-content-between mb-3"></div>

		<div class="row">
			<div class="col-md-12 mb-3">
				<div class="card mb-3">
					<div class="card-body">
						<div class="heading">
							<h4 class="">Freshbooks Notifications</h4>
						</div>
						<div class="body">
							<div class="accordion" id="invoiceNotViewed5Days">
								<!-- Invoic not viewed after 5 days -->
								<div class="accordion-item">
									<h2 class="accordion-header" id="invoiceNotViewed5DaysHeading">
										<button
											class="accordion-button collapsed"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseInvoiceNotViewed5Days"
											aria-expanded="false"
											aria-controls="collapseInvoiceNotViewed5Days"
											disabled
										>
											<font-awesome-icon
												class="me-2 text-warning fs-3"
												:icon="['fas', 'envelope']"
											/>
											Invoice Not Viewed After 5 Days
											<span class="badge bg-danger ms-2">Disabled for now 🤦‍♂️ </span>
										</button>
									</h2>
									<div
										id="collapseInvoiceNotViewed5Days"
										class="accordion-collapse collapse"
										aria-labelledby="invoiceNotViewed5DaysHeading"
										data-bs-parent="#invoiceNotViewed5Days"
									>
										<div class="accordion-body">
											<div class="alert alert-warning bg-info-lighter text-black" role="alert">
												This notification notifiing clients that not viewed invoice for 10 days,
												over LOB with intro letter and with attached invoice. Also slack
												notification is sent do selected chanel.
											</div>

											<div class="advanced-settings my-3">
												<div
													class="form-check form-switch d-flex justify-content-start align-items-center mb-2"
												>
													<input
														class="form-check-input cursor-pointer"
														type="checkbox"
														id="fiveDaysSlackOn"
														v-model="freshbooksNotificationSettings.fiveDaysSlackOn"
													/>
													<label class="form-check-label ms-2" for="fiveDaysSlackOn"
														>Notify on slack when notification is sent</label
													>
												</div>
												<div
													class="form-group mb-2"
													v-if="freshbooksNotificationSettings.fiveDaysSlackOn"
												>
													<label for="">Slack Chanel</label>
													<input
														type="text"
														class="form-control"
														v-model="freshbooksNotificationSettings.fiveDaysSlackChanel"
													/>
												</div>
												<div class="d-flex justify-content-end align-items-center">
													<button
														@click="saveFreshbooksNotificationSettings()"
														class="btn btn-primary"
													>
														Update
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- Invoic not viewed 10 days -->
								<div class="accordion-item">
									<h2 class="accordion-header" id="invoiceNotViewed10DaysHeading">
										<button
											disabled
											class="accordion-button collapsed"
											type="button"
											data-bs-toggle="collapse"
											data-bs-target="#collapseInvoiceNotViewed10"
											aria-expanded="false"
											aria-controls="collapseInvoiceNotViewed10"
										>
											<font-awesome-icon class="me-2 text-warning fs-3" :icon="['fab', 'usps']" />
											Invoice Not Viewed After 10 Days
											<span class="badge bg-danger ms-2">Disabled for now 🤦‍♂️ </span>
										</button>
									</h2>
									<div
										id="collapseInvoiceNotViewed10"
										class="accordion-collapse collapse"
										aria-labelledby="invoiceNotViewed10DaysHeading"
										data-bs-parent="#invoiceNotViewed10Days"
									>
										<div class="accordion-body">
											<div class="alert alert-warning bg-info-lighter text-black" role="alert">
												This notification is triggered when client is not viewing invoice for 5
												days. Notification send email to client with template and also notifiing
												that email is sent over slack.
											</div>
											<div>
												<div class="row">
													<div class="col-md-10">
														<label for="">Email Template</label>
														<editor
															api-key=""
															v-model="freshbooksNotificationSettings.tenDaysTemplate"
															theme="advanced"
															theme_advanced_toolbar_location="bottom"
															:init="emailTemplateToolbar"
														/>
													</div>
													<div class="col-md-2">
														<label for="">Shortcodes</label>
														<div>
															[name]
															<font-awesome-icon
																class="cursor-pointer text-primary"
																@click="copyToClipboard('[name]')"
																:icon="['fas', 'copy']"
															/>
															<br />
															[invoiceSharingLink]
															<font-awesome-icon
																class="cursor-pointer text-primary"
																@click="copyToClipboard('[invoiceSharingLink]')"
																:icon="['fas', 'copy']"
															/>
															<br />
															[address]
															<font-awesome-icon
																class="cursor-pointer text-primary"
																@click="copyToClipboard('[address]')"
																:icon="['fas', 'copy']"
															/>
															<br />
															[address_mailing]
															<font-awesome-icon
																class="cursor-pointer text-primary"
																@click="copyToClipboard('[address_mailing]')"
																:icon="['fas', 'copy']"
															/>
															<br />
															[phone]
															<font-awesome-icon
																class="cursor-pointer text-primary"
																@click="copyToClipboard('[phone]')"
																:icon="['fas', 'copy']"
															/><br />
															[website]
															<font-awesome-icon
																class="cursor-pointer text-primary"
																@click="copyToClipboard('[website]')"
																:icon="['fas', 'copy']"
															/>
															<br />
														</div>
													</div>
												</div>
											</div>
											<div class="advanced-settings my-3">
												<div class="">
													<div class="form-group mb-2">
														<label for="">Slack Message </label><br />
														<small>(You can use shortcodes from above)</small>
														<textarea
															v-model="freshbooksNotificationSettings.tenDaysSlackText"
															rows="5"
															class="form-control"
														/>
													</div>
												</div>

												<div class="form-group mb-2">
													<label for="">Slack Chanel</label>
													<input
														type="text"
														class="form-control"
														v-model="freshbooksNotificationSettings.tenDaysSlackChanel"
													/>
												</div>
												<div class="d-flex justify-content-end align-items-center pt-3">
													<button
														@click="saveFreshbooksNotificationSettings()"
														class="btn btn-primary"
													>
														Update
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import { handleErrors } from '../../actions/helpers'
import { Tooltip } from 'bootstrap'
import Editor from '@tinymce/tinymce-vue'
import restApi from '../../api/index.js'
export default {
	name: 'ClientsNotifications',
	components: { PageHeader, Editor },
	data() {
		return {
			loading: false,
			emailTemplateToolbar: {
				menubar: false,
				plugins: 'link code lists',
				toolbar1:
					'fontselect fontsizeselect formatselect lineheight | bold italic underline strikethrough | bullist numlist | alignleft aligncenter alignright alignjustify | link removeformat code',
			},
			freshbooksNotificationSettings: {
				fiveDaysSlackOn: false,
				fiveDaysSlackChanel: '',
				tenDaysTemplate: '',
				tenDaysSlackText: '',
				tenDaysSlackChanel: '',
				fifteenDaysTemplate: '',
				fifteenDaysSlackOn: false,
				fifteenDaysSlackChanel: '',
			},
			customNotification: {
				template: '',
				condition: '',
			},
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	mounted() {},
	created() {
		setTimeout(() => {
			document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
				new Tooltip(el)
			})
		}, 1100)
		this.getSettings()
	},
	methods: {
		getSettings() {
			restApi
				.get('/settings', { params: { name: 'freshbooksNotificationSettings', type: 'notificationSettings' } })
				.then(({ data }) => {
					if (data) {
						this.freshbooksNotificationSettings = JSON.parse(data.data)
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		saveFreshbooksNotificationSettings() {
			restApi
				.post('/settings', {
					name: 'freshbooksNotificationSettings',
					type: 'notificationSettings',
					data: JSON.stringify(this.freshbooksNotificationSettings),
				})
				.then(({ data }) => {
					data.data = JSON.parse(data.data)
					this.freshbooksNotificationSettings = data.data
					this.$swal.fire({
						icon: 'success',
						title: 'Settings successfully saved!',
						timer: 4000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		copyToClipboard(text) {
			navigator.clipboard.writeText(text).then(() => {
				console.log('Copied!')
			})
		},
	},
	filters: {
		removeString: function(value) {
			if (!value) return ''
			value = value.replace('&laquo;', '')
			return value.replace('&raquo;', '')
		},
	},
}
</script>
